"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var type_rest_1 = require("type-rest");
var apiRoot = process.env.API_ROOT ? process.env.API_ROOT : process.env.VUE_APP_API_ROOT;
exports.Api = type_rest_1.typeRest(apiRoot, {
    params: {
        mode: "cors",
    },
    hooks: [
        {
            type: "post",
            hook: function (ev) {
                if (ev.response.status === 403) {
                    console.log("TYPE REST HOOK");
                }
            },
        },
        {
            type: "post",
            path: "/auth/",
            method: "POST",
            hook: function (ev) {
                ev.instance._options.params.headers.token = ev.response.token;
            },
        },
        {
            type: "post",
            path: "/auth/",
            method: "DELETE",
            hook: function (ev) {
                if (ev.response.valid) {
                    ev.instance._options.params.headers.token = undefined;
                    delete ev.instance._options.params.headers.token;
                }
            },
        },
    ],
});
//# sourceMappingURL=index.js.map